import React from 'react'
import { withRouter } from 'react-router-dom'
import MUIDataTable from "mui-datatables"
import moment from 'moment'
import {
	CircularProgress,
	IconButton,
	Button
} from '@material-ui/core'
import {
	Delete,
	Edit,  
	Check,
	Close
} from '@material-ui/icons'
import { table_options } from '../../constants/table'
import { 
	get_query,
	delete_query
} from './../../functions'
import { UniConfirm } from './../../containers/ui'
import UpControl from './../../containers/modules/UpControl'


// branch solutions
class Branchsols extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			loader: false,
			data: [],
			paginator: {}
		}
	}

	componentDidMount(){
		this.getData()
	}

	getData(){
		this.setState({ loader: true  })
		get_query('/api/branchsols')
		.then((res) => {
			this.setState({ data: res, loader: false  })
		})
		.catch((err) => {
			console.log(err)
			this.setState({ data: [], loader: false })
		})
	}

	deleteRow(id){
		this.setState({ loader: true  })
		delete_query(`/api/branchsols/${id}`)
		.then(() => {
			this.getData()
		})
		.catch((err) => {
			this.setState({ loader: false  })
		})
	}

	confCols(){
		let cols = [{
			name: "name",
			label: "Категория",
			options: {
				filter: false,
				sort: false,
			}
		},{
			name: "updated_at",
			label: "Обновлено", 
			options: {
				filter: false,
				sort: false,
				customBodyRender: (val) => (
					<>
						{
							val ? (
								<span>
									{moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')} 
								</span>
							) : false
						}
					</>
				)
			}
		},{
			name: "viewrecord",
			label: "Показывать",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (val) => (
					<>
						{
							val ? 
								<Check style={{ color: 'green' }}/> :
								<Close style={{ color: 'red' }}/>
								
						}
					</>
				)
			}
		},{ 
			name: 'id',
			label: 'Действия',
			options: {
				filter: false,
				sort: false,
				customBodyRender: (val) => (
					<div style={{ width: 180 }}>
						<IconButton
							color='primary'
							onClick={() => this.props.history.push(`/branchsols/edit/${val}`)}
						>
							<Edit />
						</IconButton>
						<UniConfirm
							action={() => this.deleteRow(val)}
						>
							<IconButton
								color='secondary'
							>
								<Delete />
							</IconButton>
						</UniConfirm>
					</div>
				)
			}
		}]
		return cols
	}

	render(){
		return(
			<div>
				<UpControl>
					<Button
						variant='contained'
						color='primary'
						onClick={() => this.props.history.push('/branchsols/new')}
					>
						Добавить категорию
					</Button>
				</UpControl>
				<MUIDataTable
					title={this.state.loader ? <CircularProgress /> : "Отраслевые решения Zig-Zag"}
					data={this.state.data}
					columns={this.confCols()}
					options={table_options}
				/>
			</div>
		)
	}
}

export default withRouter(Branchsols)


